import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Tooltip from 'flarum/common/components/Tooltip';
import {fragment as Fragment} from "mithril";

export default class LevelBar extends Component {
  view() {
    const userRank = (this.attrs as any).user.data.attributes.userRank;

    const expTotal = userRank.experience,
      expLevel = userRank.rank,
      nextLevelTotalExp = userRank.nextRankExperience - userRank.rankExperience,
      nextLevelExp = userRank.experience - userRank.rankExperience,
      expPercent = nextLevelExp / nextLevelTotalExp * 100;

    return (
      <Tooltip text={app.translator.trans('rhodes-island.forum.ranks.experienceText', { expTotal, nextLevelExp: userRank.nextRankExperience - userRank.experience })}>
        <div class="PostUser-level">
          <span class="PostUser-text">
            <span class="PostUser-levelText">{app.translator.trans("rhodes-island.forum.ranks.levelText")}</span>
            &nbsp;
            <span class="PostUser-levelPoints">{expLevel}</span>
          </span>
          <div class="PostUser-bar">
            <div class="PostUser-bar--inner" style={'width: ' + expPercent + '%;'}></div>
          </div>
        </div>
      </Tooltip>
    );
  }
}
